var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2126 4.67182C12.4958 4.94519 12.4958 5.3884 12.2126 5.66177L7.37845 10.3284C7.09528 10.6018 6.63615 10.6018 6.35298 10.3284L1.78738 5.92103C1.5042 5.64766 1.5042 5.20445 1.78738 4.93108C2.07056 4.65771 2.52968 4.65771 2.81286 4.93108L6.86572 8.84351L11.1871 4.67182C11.4703 4.39846 11.9294 4.39846 12.2126 4.67182Z",
    fill: "#071437"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/down-arrow-icon.7646c308e0e1c06e9238e4a579d48ec9.svg";
export { ForwardRef as ReactComponent };